import { render, staticRenderFns } from "./TxnComments.vue?vue&type=template&id=37945109&scoped=true&"
import script from "./TxnComments.vue?vue&type=script&lang=js&"
export * from "./TxnComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37945109",
  null
  
)

export default component.exports